"use strict";

var RosterService = require('./roster');

var RecognitionService = require('./recognition');

var CompanyService = require('./company');

var BrandingService = require('./branding');

var CashierService = require('./cashier');

var BudgetService = require('./budget');

var CMXService = require('./cmx');

var CatalogService = require('./catalog');

var ProfileService = require('./profile');

var SolutionService = require('./solution');

module.exports = function (context) {
  return {
    rosterService: new RosterService(context),
    recognitionService: new RecognitionService(context),
    companyService: new CompanyService(context),
    brandingService: new BrandingService(context),
    cashierService: new CashierService(context),
    budgetService: new BudgetService(context),
    cmxService: new CMXService(context),
    catalogService: new CatalogService(context),
    profileService: new ProfileService(context),
    solutionService: new SolutionService(context)
  };
};
//# sourceMappingURL=index.js.map